import targetGroupHelpers from "../../Utils/targetGroups";
import {targetGroupConfigurations} from "../../Constants/VOSS/targetGroups";
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {bindActionCreators} from "redux";
import formActionsImp from "../../Actions/formActions";
import TargetGroupActionsImp from "../../Actions/Voss/targetGroupActions";
export default function useCustomerExpiryDate(form) {
    const dispatch = useDispatch();
    const [showExpiryDate, setShowExpiryDate] = useState(false);
    const formActions = bindActionCreators(formActionsImp, dispatch);
    const targetGroupsActions = bindActionCreators(TargetGroupActionsImp, dispatch);
    const targetGroups = useSelector((state) => state.TargetGroupsReducer.targetGroups);

    useEffect(() => {
        if (!targetGroups) {
            targetGroupsActions.getTargetGroups();
        }
    }, []);

    function isExpiryDateRequired () {
        return targetGroupHelpers.hasConfig(targetGroups, form?.data?.targetGroups, targetGroupConfigurations.expiryDateRequired);
    }

    const oneYearFromToday = () => {
        const today = new Date();
        today.setFullYear(today.getFullYear() + 1);
        return today;
    };

    useEffect(() => {
        if (!form) return;
        formActions.changeMultiFormField(form, "expiryDate", showExpiryDate ? oneYearFromToday() : null);
    }, [showExpiryDate]);

    useEffect(() => {
        setShowExpiryDate(isExpiryDateRequired());
    }, [form?.data?.targetGroups, targetGroups]);

    useEffect(() => {
        if (!form || !showExpiryDate)
            return;

        const expiryDate = form?.data?.expiryDate

        if (!expiryDate) {
            formActions.updateFieldErrorFlags(form, "expiryDate",{expiryDate : "Expiry date is required for test customers"});
        }

        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        const oneYearFromTodayDate = oneYearFromToday();

        if (expiryDate <= yesterday || expiryDate >= oneYearFromTodayDate) {
            formActions.updateFieldErrorFlags(form, "expiryDate", { expiryDate: "Expiry date needs to be within a year" });
        }
    }, [form?.data?.expiryDate]);
    
    return {
        showExpiryDate,
    }
}